// import { IButtonMenu } from '@wangeditor/core'
// import { Boot } from '@wangeditor/editor'
// import QUOTE_SVG from '@/assets/img/bell.png'
import { Editor, Transforms } from "slate";
import {
  // IModalMenu,
  // IDomEditor,
  genModalInputElems,
  genModalButtonElems,
  t,
} from "@wangeditor/core";
import { DomEditor } from "@wangeditor/editor";
import $ from "./dom";
import { genRandomStr } from "./util";
// import withVideo from './w.js'
function genDomID() {
  return genRandomStr("w-e-insert-video");
}

// 定义菜单 class
class MyButtonMenu {
  title = "名片";
  iconSvg = "";
  mark = "名片";
  tag = "button";
  showModal = true;
  modalWidth = 320;
  $content = null;
  srcInputId = genDomID();
  srcInputId2 = genDomID();
  srcInputId3 = genDomID();
  srcInputId4 = genDomID();
  buttonId = genDomID();
  getValue(editor) {
    // 用不到 getValue
    console.log(editor);
    return "";
  }
  isActive(editor) {
    console.log(editor);
    // 任何时候，都不用激活 menu
    return false;
  }
  isDisabled(editor) {
    if (editor.selection == null) return true;

    const [nodeEntry] = Editor.nodes(editor, {
      match: (n) => {
        const type = DomEditor.getNodeType(n);

        // 只可用于 p 和 blockquote
        if (type === "paragraph") return true;
        if (type === "blockquote") return true;

        return false;
      },
      universal: true,
      mode: "highest", // 匹配最高层级
    });

    // 匹配到 p blockquote ，不禁用
    if (nodeEntry) {
      return false;
    }
    // 未匹配到，则禁用
    return true;
  }
  getModalPositionNode(editor) {
    console.log(editor);
    return null; // modal 依据选区定位
  }

  getModalContentElem(editor) {
    const { srcInputId, buttonId, srcInputId2, srcInputId3, srcInputId4 } =
      this;

    // // 获取 input button elem
    // const [$srcContainer, $inputSrc] = genModalInputElems(
    //   t('videoModule.videoSrc'),
    //   srcInputId,
    //   t('videoModule.insertPlaceHolder')
    // )
    // const [$buttonContainer] = genModalButtonElems(buttonId, t('videoModule.ok'))

    // if (this.$content == null) {
    //   // 第一次渲染
    //   const $content = $('<div></div>')
    //   // 绑定事件（第一次渲染时绑定，不要重复绑定）
    //   $content.on('click', `#${buttonId}`, async e => {
    //     e.preventDefault()
    //     // const src = $(`#${srcInputId}`).val().trim()
    //     await this.insertVideo(editor)
    //     editor.hidePanelOrModal() // 隐藏 modal
    //   })

    //   // 记录属性，重要
    //   this.$content = $content
    // }

    // const $content = this.$content
    // $content.html('') // 先清空内容

    // // append inputs and button
    // $content.append($srcContainer)
    // $content.append($buttonContainer)

    // // 设置 input val
    // $inputSrc.val('')

    // // focus 一个 input（异步，此时 DOM 尚未渲染）

    // let value = 1111;
    let li = window.document.createElement("div");
    li.innerHTML = `
                    <label class='babel-container'>
                    <span>头像地址</span>
                    <input type="text" id="${srcInputId}" placeholder="请输入头像地址">
                    </label>
                    <label class='babel-container'>
                    <span>名称</span>
                    <input type="text" id="${srcInputId2}" placeholder="请输入名称">
                    </label>
                    <label class='babel-container'>
                    <span>说明</span>
                    <input type="text" id="${srcInputId3}" placeholder="请输入说明">
                    </label>
                    <label class='babel-container'>
                    <span>跳转地址</span>
                    <input type="text" id="${srcInputId4}" placeholder="请输入跳转地址">
                    </label>

                    <div class="button-container">
                      <button type="button" id="${buttonId}">确定</button>
                    </div>
                    `;
    console.log(document.getElementById(buttonId));
    console.log(this);
    setTimeout(() => {
      document.getElementById(buttonId).onclick = async (params) => {
        console.log(params);
        let a = document.getElementById(srcInputId).value;
        let b = document.getElementById(srcInputId2).value;
        let c = document.getElementById(srcInputId3).value;
        let d = document.getElementById(srcInputId4).value;
        console.log(a);
        await this.insertVideo(editor, a, b, c, d);
        editor.hidePanelOrModal(); // 隐藏 modal
      };
    });
    setTimeout(() => {
      $(`#${srcInputId}`).focus();
    });
    return li;
  }
  exec(editor) {
    console.log(editor);
    // // let src = ''
    // if (this.isDisabled(editor)) return
    // // 还原选区
    // editor.restoreSelection()

    // if (this.isDisabled(editor)) return

    // // 新建一个 video node
    // const ccc = {
    //   type: 'card',
    //   children: [{text:''}], // 【注意】void node 需要一个空 text 作为 children
    // }

    // // 插入视频
    // // 不使用此方式会比正常的选区选取先执行
    // Promise.resolve().then(() => {
    //   Transforms.insertNodes(editor, ccc)
    // })
  }
  insertVideo(editor, a, b, c, d) {
    // 还原选区
    editor.restoreSelection();

    if (this.isDisabled(editor)) return;

    // 新建一个 video node
    const ccc = {
      type: "OfficialAccounts",
      a, b, c, d,
      children: [{ text: "" }], // 【注意】void node 需要一个空 text 作为 children
    };

    // 插入视频
    // 不使用此方式会比正常的选区选取先执行
    Promise.resolve().then(() => {
      Transforms.insertNodes(editor, ccc);
    });
  }
}

// 定义菜单配置
export const menuConf = {
  key: "OfficialAccountsMenu", // menu key ，唯一。注册之后，可配置到工具栏
  factory() {
    return new MyButtonMenu();
  },
};

export default menuConf;
// 注册到 wangEditor
// Boot.registerMenu(menuConf)
